<div class="variaveis-lista-container">

    <div class="vl-toolbar">
        <mat-form-field appearance="outline" class="vl-search-field" subscriptSizing="dynamic">
            <mat-label>Pesquisar variável</mat-label>
            <input matInput [formControl]="searchControl" placeholder="Nome, código, descrição...">
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </div>

    <div class="vl-chips">
        @if (variavelFiltradas.length === 0) {
        <app-empty-state
            icon="search_off"
            title="Nenhuma variável encontrada"
            subtitle="Ajuste a pesquisa para encontrar as variáveis desejadas.">
        </app-empty-state>
        }
        @for (v of variavelFiltradas; track variavelChave(v)) {
        <button class="status-badge badge-variavel" [ngClass]="classeBadgeVariavel(v)" type="button" (click)="inserir(v)" [title]="tooltipVariavel(v)" [attr.data-chave]="variavelChave(v)">
            @if (isVariavelParametro(v)) { <span class="material-symbols-outlined" aria-label="Parâmetro de configuração" title="Parâmetro de configuração">settings</span> }
            @if (v.possuiFormulaAplicavel) { <span class="material-symbols-outlined" aria-label="Possui fórmula aplicável" title="Possui fórmula aplicável">function</span> }
            <span class="variavel-badge-descricao">{{ v.descricao }}</span>
            <code class="variavel-badge-nome">{{ '{' + v.nome + '}' }}</code>
        </button>
        }
    </div>

    <div class="vl-footer">
        {{ variavelFiltradas.length }} variáveis disponíveis · clique para inserir
    </div>

</div>
